
import React, { useState } from 'react';
import { UserIcon } from 'styles/components/Icons';
import { DropdownLink, Dropdown } from 'styles/components/Nav.styles';
import { logout } from 'mrf/utils/LoginUtils';
import useCurrentUser from 'mrf/utils/useCurrentUser';
import T from 'mrf/utils/T';
import Flex from 'mrf/layout/Flex';

const TDropdownLink = ({ children, ...props }) => <DropdownLink {...props}><T>{children}</T></DropdownLink>;

export default function UserDropdown() {
    const user = useCurrentUser();

    const [visible, setVisible] = useState(false);
    const hide = () => setVisible(false);
    const toggle = () => setVisible(!visible);

    return (
        <>
            <Dropdown
                interactiveBorder={20}
                arrow={false}
                interactive
                onClickOutside={hide}
                visible={visible}
                content={
                    <Flex direction='col'>
                        <TDropdownLink
                            to='/profile'
                            onClick={hide}
                        >
                            Profile
                        </TDropdownLink>
                        <TDropdownLink
                            as='button'
                            onClick={logout}
                        >
                            Logout
                        </TDropdownLink>
                    </Flex>
                }
            >
                <UserIcon
                    className='nav-icon'
                    size='30'
                    title=''
                    onClick={toggle}
                />
            </Dropdown>
            <p>{user?.userName}</p>
        </>
    );
}
